import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach Bearer token from localStorage on every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("qc_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, drop the stale token
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("qc_token");
      // window dispatch for AuthContext
      window.dispatchEvent(new Event("qc-unauth"));
    }
    return Promise.reject(err);
  }
);

export const fileUrl = (path) => `${API}/files/${path}`;

// === Auth ===
export const authBootstrap = async () => (await client.get("/auth/bootstrap")).data;
export const authLogin = async (email, password) =>
  (await client.post("/auth/login", { email, password })).data;
export const authRegister = async (email, password, name) =>
  (await client.post("/auth/register", { email, password, name })).data;
export const authMe = async () => (await client.get("/auth/me")).data;
export const authLogout = async () => (await client.post("/auth/logout")).data;

// === Users (admin) ===
export const listUsers = async () => (await client.get("/users")).data;
export const createUser = async (payload) => (await client.post("/users", payload)).data;
export const updateUser = async (id, payload) => (await client.put(`/users/${id}`, payload)).data;
export const deleteUser = async (id) => (await client.delete(`/users/${id}`)).data;

// === Templates ===
export const uploadTemplate = async (file, name, productName) => {
  const fd = new FormData();
  fd.append("file", file);
  if (name) fd.append("name", name);
  fd.append("product_name", productName);
  const { data } = await client.post("/templates/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
export const listTemplates = async () => (await client.get("/templates")).data;
export const getTemplate = async (id) => (await client.get(`/templates/${id}`)).data;
export const deleteTemplate = async (id) => (await client.delete(`/templates/${id}`)).data;

// === Products ===
export const listProducts = async () => (await client.get("/products")).data;
export const getLatestForProduct = async (productName) =>
  (await client.get(`/products/${encodeURIComponent(productName)}/latest`)).data;

// === Photos ===
export const uploadPhoto = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await client.post("/upload/photo", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// === Versions ===
export const saveVersion = async (templateId, payload) =>
  (await client.post(`/templates/${templateId}/versions`, payload)).data;
export const listAllVersions = async () => (await client.get("/versions")).data;
export const deleteVersion = async (templateId, versionId) =>
  (await client.delete(`/templates/${templateId}/versions/${versionId}`)).data;

// === Settings ===
export const getSettings = async () => (await client.get("/settings")).data;
export const updateSettings = async (payload) =>
  (await client.put("/settings", payload)).data;
export const uploadLogo = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await client.post("/settings/logo", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};
export const clearLogo = async () => (await client.delete("/settings/logo")).data;

export default client;
